import { render, staticRenderFns } from "./SiteFormsList.vue?vue&type=template&id=39be700e&"
import script from "./SiteFormsList.vue?vue&type=script&lang=js&"
export * from "./SiteFormsList.vue?vue&type=script&lang=js&"
import style0 from "./SiteFormsList.vue?vue&type=style&index=0&id=39be700e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports